import { SvgChat } from '@/components/common/Icons/Chat';

type GoogleSuggestionProps = {
	googleSuggestions: string[];
	handleSelectSuggestion: (suggestion: string) => void;
	paddingTop?: string;
	suggestionOnTop?: boolean;
};

export const GoogleSuggestion = ({
	googleSuggestions,
	handleSelectSuggestion,
	paddingTop,
	suggestionOnTop,
}: GoogleSuggestionProps) => {
	if (googleSuggestions.length === 0) {
		return null;
	}

	const renderContent = () => {
		return googleSuggestions.map((question) => (
			<div
				key={question}
				className="flex items-center px-2.5 py-2 bg-grey-4 group justify-between rounded-[10px] transition-colors duration-200"
			>
				<span className="text-base-black font-medium group-hover:text-gray-900">
					{question}
				</span>
				<button
					className="cursor-pointer"
					type="button"
					aria-label="Chat"
					onClick={() => handleSelectSuggestion(question)}
				>
					<SvgChat height={23} width={23} />
				</button>
			</div>
		));
	};

	const containerHeight = 'h-[300px]';
	const containerPadding = 'pb-[30px] mb-[-35px] border-b-0 rounded-t-[20px]';

	return (
		<div
			className={`bg-white border border-grey-2 p-2.5${
				suggestionOnTop
					? ` ${containerPadding}`
					: `border-t-0 mt-[-35px] rounded-b-[20px] ${paddingTop}`
			} transition-all duration-300 ease-in-out`}
		>
			<div
				className={`flex flex-col gap-2.5 ${containerHeight} overflow-y-auto pr-2 [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-grey-2 [&::-webkit-scrollbar-thumb]:rounded-full`}
			>
				{renderContent()}
			</div>
		</div>
	);
};
